/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InsuranceEndorsementsDirective {
    public restrict = 'E';
    public scope;
    public template;
    constructor(private Process: IProcessService, private bsLoadingOverlayService: IBsLoadingService) {
        this.restrict = 'E';
        this.template = `
            <table
                id="highlightElement22" style="text-align-last: center"
                class="table table-material md-custom-table br-normal">
                <thead>
                    <tr>
                        <th class="first_col sorted_by_this">Name</th>
                        <th class="d-none d-md-table-cell">Uploaded Date</th>
                        <th class="d-none d-md-table-cell" ng-if="tabIndex !== 'templates' && tabIndex !== 'guide'">Employees</th>
                        <th class="d-none d-md-table-cell">Files</th>
                        <th class="d-none d-md-table-cell" ng-if="tabIndex !== 'templates' && tabIndex !== 'guide'">Status</th>
                        <th class="d-none d-md-table-cell" ng-if="tabIndex !== 'templates'&& tabIndex !== 'guide'">Status Date</th>
                        <th class="d-none d-md-table-cell" ng-if="tabIndex !== 'templates'&& tabIndex !== 'guide'">Request Type</th>
                        <th class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">Edit</th>
                        <th class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">Delete</th>
                        <th class="w-20">
                            <md-button class="md-icon-button md-primary" ng-click="C.openEndorsementLoadDocumentsModal({}, 'Add')">
                                <md-icon md-font-library="material-icons" class="p-0">add_circle</md-icon>
                            </md-button>
                        </th>
                    </tr>
                </thead>
                <tbody
                    ng-repeat="document in typeArray track by $index">
                    <tr>
                        <td class="first_col sorted_by_this b-word">
                            {{ document.description }}</td>
                        <td class="d-none d-md-table-cell" ng-if="C.checkIfDocument(document.description)">{{ document.uploadedDate | date: 'dd.MM.yyyy' }}</td>
                        <td class="d-none d-md-table-cell" 
                            ng-if="C.checkIfDocument(document.description) && tabIndex !== 'templates' && tabIndex !== 'guide'">
                                {{ document.employeeList.length}}
                                <md-tooltip md-direction="bottom">{{ nameString.join(';  ') }}</md-tooltip>
                        </td>
                        <td class="d-none d-md-table-cell" ng-if="C.checkIfDocument(document.description)">{{ document.files.length}}</td>
                        <td ng-if="C.checkIfDocument(document.description) && tabIndex !== 'templates' && tabIndex !== 'guide'"">
                            <md-select 
                                class="lh-initial capital-text", 
                                ng-model="document.status", 
                                ng-click="edit()", 
                                ng-change="C.changeEndorsementStatus(document)", 
                                ng-disabled="!C.User.hasPermission('org.change_org') || tabIndex === 'templates'|| tabIndex === 'guide'">
                                <md-option class="capital-text" ng-repeat="status in options track by $index" ng-value="status">
                                    {{status}}
                                </md-option>
                            </md-select>
                        </td>
                        <td class="d-none d-md-table-cell" ng-if="C.checkIfDocument(document.description) && tabIndex !== 'templates' && tabIndex !== 'guide'"">{{ document.statusDate | date: 'dd.MM.yyyy' }}</td>
                        <td class="d-none d-md-table-cell" ng-if="C.checkIfDocument(document.description) && tabIndex !== 'templates' && tabIndex !== 'guide'"">{{ document.requestType }}</td>
                        <td class="p-0 d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org') && C.checkIfDocument(document.description)">
                            <md-button type="button"
                                    data-toggle="modal" data-target="#FileEditModal"
                                    ng-click="C.openEndorsementLoadDocumentsModal(document, 'Edit')"
                                    class="md-icon md-primary cus-md-icon-button"><md-icon
                                        md-font-library="material-icons"
                                        class="p-0">edit</md-icon>
                            </md-button>
                        </td>
                        <td class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org') && C.checkIfDocument(document.description)">
                            <md-button class='md-icon md-warn cus-md-icon-button m-0 w-unset' ng-click='C.deleteEndorsementGroup(document.id)'>
                                <md-icon class='p-0' md-font-library='material-icons'>
                                    delete_forever                    
                                </md-icon>
                            </md-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        `
    }

    public link($scope: any, $element: any, attrs: any): void {
        const tabSelected = attrs.tab;
        $scope.currentPage=1;
        $scope.numLimit=10;
        $scope.start = 0;
        $scope.typeArray = [];
        $scope.nameString = [];
        $scope.countArray = [];
        $scope.queryType = attrs.tab;
        $scope.index = attrs.index;
        $scope.options = [
            'Uploaded',
            'Under Review',
            'Sent To Provider',
            'Pending Info',
            'Completed'
        ];
        $scope.tabIndex = attrs.index;
        $scope.$watch(() => attrs.val, (n) => {
            if (n !== '') {
                const parseData = JSON.parse(n);
                $scope.typeArray = parseData.filter(data => data.status === tabSelected);
                $scope.nameString = $scope.typeArray.map((doc) => doc.employeeList.map((empl) => empl.name))[0];
                $scope.pages=Math.ceil($scope.typeArray.length/$scope.numLimit);
                if ($scope.typeArray.length === 0) {
                    $scope.typeArray.push({description:'No documents'})
                }
            }
        });
        $scope.hideNext=function(){
            if(($scope.start+ $scope.numLimit) < $scope.typeArray.length){
              return false;
            }
            else 
            return true;
          };
        $scope.hidePrev=function(){
        if($scope.start===0){
            return true;
        }
        else 
        return false;
        };
        $scope.nextPage=function(){
            $scope.currentPage++;
            $scope.start=$scope.start+ $scope.numLimit;
        };
        $scope.PrevPage=function(){
            if($scope.currentPage>1){
                $scope.currentPage--;
              }
              $scope.start=$scope.start - $scope.numLimit;
        }

        if ($scope.value === '---') {
            $scope.value = undefined;
        }

        $scope.change = function (index): any {
            if ($scope.changeFunc !== undefined) {
                var changeObj: any = {
                    new: $scope.typeArray
                };
                $scope.changeFunc({args: changeObj});
            }
            $scope.doneEdit($scope.typeArray[index]);
        };

        // $scope.edit = function (): any {
        //     //$scope.editing = true;
        //     this.currentValue = $scope.value;
        //     // $element.addClass('active');
        //     // $element.addClass('');
        // };

        $scope.doneEdit = function (docObje): any {
            // $scope.editing = false;
            var newValue: any = docObje;
            // $element.removeClass('active');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
        };

        $scope.openDocModal = function (docObje): any {
            var newValue: any = docObje;
            // $element.removeClass('active');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.openModal!== undefined) {
                // console.log("open doc modal", docObje);
                $scope.openModal(docObje);
            }
        };

        // $scope.undo = function (): any {
        //     // $element.removeClass('active');
        //     $scope.value = this.currentValue;
        // };
    }



    public static DirectiveFn(
        Process: IProcessService,
        bsLoadingOverlayService: IBsLoadingService
    ): InsuranceEndorsementsDirective {
        return new InsuranceEndorsementsDirective(Process, bsLoadingOverlayService);
    }

}

InsuranceEndorsementsDirective.DirectiveFn.$inject = ['Process', 'bsLoadingOverlayService'];

angular.module('beneple.global').directive('insuranceEndorsementsTab', InsuranceEndorsementsDirective.DirectiveFn);


// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/insurance_endorsements.directive.ts